import { QueryKey } from "@saas/account/config";
import { getOryAttributes, getOryCsrf } from "@saas/account/utils";

import { kratos } from "../..";

import { RegistrationFlow } from "@ory/client";
import { useQuery } from "@tanstack/react-query";

export const useRegisterQuery = <T = undefined>(
  select?: (data: RegistrationFlow) => T,
  enabled?: boolean,
  redirect?: string,
  onError?: (error: { id: string }) => void
) => {
  return useQuery<RegistrationFlow, { id: string }, T>(
    [QueryKey.AUTH_REGISTER],
    () =>
      kratos
        .createBrowserRegistrationFlow()
        .then(({ data }) => data)
        .catch((error) => {
          throw error.response.data.error;
        }),
    {
      select,
      enabled,
      onError,
      retry: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
    }
  );
};

export const getRegistrationFormData = ({ id, ui }: RegistrationFlow) => {
  const passwordNodes = ui?.nodes?.filter(
    (node) => node.group === "default" || node.group === "password"
  );

  return {
    id,
    csrfToken: getOryCsrf(passwordNodes),
    method: getOryAttributes(passwordNodes, "method"),
    identifier: getOryAttributes(passwordNodes, "identifier"),
    password: getOryAttributes(passwordNodes, "password"),
    error: ui?.messages?.[0],
  };
};

export const useRegistrationFormQuery = (
  enabled = true,
  redirect?: string,
  onError?: (error: { id: string }) => void
) => {
  return useRegisterQuery(getRegistrationFormData, enabled, redirect, onError);
};

export default useRegisterQuery;
